import type { AriaRole, FC, ReactNode, SVGProps } from 'react'
import { Link } from 'react-router'

import { combineClassnames } from 'app/common/presentation'

import styles from './Menu.module.scss'

interface MenuItemProps {
  chip?: string
  className?: string
  disabled?: boolean
  icon?: FC<SVGProps<SVGSVGElement>>
  label: ReactNode
  leading?: ReactNode
  onClick?: () => void
  role?: AriaRole
  selected?: boolean
  state?: unknown
  to?: string
}

const MenuItem = ({
  chip,
  className,
  disabled = false,
  icon: Icon,
  label,
  leading,
  onClick,
  role,
  selected = false,
  state,
  to,
}: MenuItemProps) => {
  const interactive = (to !== undefined || onClick !== undefined) && !disabled
  const content = (
    <>
      {leading}
      {Icon && <Icon className={styles.icon} />}
      <span className={styles.label}>{label}</span>
      {chip && <span className={styles.chip}>{chip}</span>}
    </>
  )

  const classNames = combineClassnames(
    styles.menuItem,
    interactive ? styles.interactive : undefined,
    selected ? styles.selected : undefined,
    disabled ? styles.disabled : undefined,
    className,
  )

  if (to && !disabled) {
    return (
      <Link className={classNames} role={role} state={state} to={to}>
        {content}
      </Link>
    )
  }

  if (onClick && !disabled) {
    return (
      <button className={classNames} onClick={onClick} role={role} type="button">
        {content}
      </button>
    )
  }

  return (
    <div className={classNames} role={role}>
      {content}
    </div>
  )
}

export default MenuItem
